/* eslint-disable no-unneeded-ternary */
import React, { useContext } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import { useStyles } from '@mummssoftware/common-ui/VisitAttributeSelector';
import { VisitContext } from '../Context/contexts/VisitContext';
import { SET_IPU_RADIO_CHOICE } from '../Context/constants';
import { IPUChoice } from '../../components/layout/VisitWrapper';

type RadioVisitMenuProps = {
  ipuVisitChoices: Record<string, string>;
};

export const RadioVisitMenu = ({ ipuVisitChoices }: RadioVisitMenuProps) => {
  const classes = useStyles();
  const { ipuRadioChoice, dispatchVisit } = useContext(VisitContext);

  const ipuMenu = Object.entries(ipuVisitChoices);

  const handleRadioChange = (event: any) => {
    dispatchVisit({
      type: SET_IPU_RADIO_CHOICE,
      payload: event.target.value,
    });
  };

  const getRadioIPU = (config: any) =>
    config.map((option: any, i: number) => (
      <FormControlLabel
        id={`-${option[0]}-${i}`}
        value={option[0]}
        key={option[0]}
        control={<Radio size="small" />}
        label={option[1]}
        classes={{
          label: classes.radioLabel,
          root: classes.radioLabel,
        }}
      />
    ));

  return (
    <IPUChoice id="radio-choice-visit">
      <RadioGroup
        aria-label="radio-print"
        name="radio-print"
        value={ipuRadioChoice}
        onChange={(event) => handleRadioChange(event)}
      >
        {getRadioIPU(ipuMenu)}
      </RadioGroup>
    </IPUChoice>
  );
};
